/* Generated by ./script/iconify.js */
/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconDocumentEditOutline = ({ className, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--documenteditoutline',
    className,
  )

  return (
    <IconBase className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"{...rest}><path className="path1" d="M8 12h8v2H8v-2m2 8H6V4h7v5h5v3.1l2-2V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4v-2m-2-2h4.1l.9-.9V16H8v2m12.2-5c.1 0 .3.1.4.2l1.3 1.3c.2.2.2.6 0 .8l-1 1-2.1-2.1 1-1c.1-.1.2-.2.4-.2m0 3.9L14.1 23H12v-2.1l6.1-6.1 2.1 2.1z"/></IconBase>
  )
}

IconDocumentEditOutline.propTypes = {
  className: PropTypes.string,
}

export default IconDocumentEditOutline
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/icons/IconDocumentEditOutline.js